import React from 'react';
import format from 'date-fns/format';
import PropTypes from 'prop-types';
import Ad from './NewsAd';
import styles from './NewsAndAds.scss';
import { logError } from '../../../shared/log';
import { CHANNEL_PROP_TYPES } from '../../../shared/model/types';
import {
  ARTICLES_PROP_TYPES,
} from '../model/types';
import Link from '../../../shared/components/Link';
import { withUserAgent } from '../../../shared/userAgentContext';

const { getCookie } = require('../../../client/cookie/cookieService');

export class NewsAndAds extends React.Component {
  static propTypes = {
    isDesktop: PropTypes.bool.isRequired,
    currentChannel: CHANNEL_PROP_TYPES.isRequired,
    articles: ARTICLES_PROP_TYPES.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      preferredState: 'null',
      showAds: false,
    };
  }

  componentDidMount() {
    let preferredState;
    try {
      preferredState = getCookie('preferred_state');
    } catch (err) {
      logError(err);
    }

    if (preferredState) {
      this.setState({ preferredState });
    }
    window.addEventListener('load', this.showAdsFunc);
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.showAdsFunc);
  }

  showAdsFunc = () => {
    this.setState({
      showAds: true,
    });
  }

  render() {
    const formatDate = dateStr => format(dateStr, 'D MMM YYYY');
    const backgroundImage = image => (image ? `url(${image})` : 'none');
    const { isDesktop } = this.props;

    return (
      <section className={styles.container}>
        <h2 className={styles.title}>Latest commercial property news</h2>
        <div className={styles.newsAndAdsLayout}>
          <div className={styles.news}>
            <ul className={styles.layout}>
              {
                this.props.articles.map((article, index) => {
                  const { largeImage, smallImage, title, label, date, description, url } = article;
                  const mainArticle = index === 0;
                  const image = mainArticle ? largeImage : smallImage;

                  return (
                    <li key={`news-${title}`} className={mainArticle ? styles.mainArticle : styles.article}>
                      <div className={mainArticle ? styles.mainArticleImageWrapper : styles.articleImageWrapper} style={{ backgroundImage: backgroundImage(image) }}>
                        <img className={mainArticle ? styles.mainArticleImage : styles.articleImage} src={image} loading="lazy" alt={title} />
                      </div>
                      <div className={mainArticle ? styles.mainContent : styles.articleContent}>
                        <h3 className={mainArticle ? styles.mainArticleTitle : styles.articleTitle}>{title}</h3>
                        <p className={styles.labelAndDate}>
                          <span className={styles.label}>{label.toUpperCase()}</span>
                          <span className={styles.date}>{formatDate(date)}</span>
                        </p>
                        <p className={mainArticle ? styles.mainDescription : styles.articleDescription}>{description}</p>
                        <p className={mainArticle ? styles.mainMoreLink : styles.articleMoreLink}>
                          <Link
                            className={styles.link}
                            href={url}
                            title={title}
                          >
                            Read more
                          </Link>
                        </p>
                      </div>
                    </li>
                  );
                })
              }
            </ul>
            <div className={styles.organisations}>
              <p className={styles.organisationsLabel}>Powered by Australia’s leading commercial property news organisations:</p>
              <div className={styles.organisationLogos}>
                <Link
                  className={styles.logo}
                  href="http://www.realcommercial.com.au/news/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={styles.realcommercialLogo}
                    src="https://realcommercial.com.au/listing-ui-assets/img/rca-logo-black.svg?v=2"
                    loading="lazy"
                    alt="realcommercial.com.au"
                    title="Commercial property for sale and lease"
                  />
                </Link>
                <Link
                  className={styles.logo}
                  href="http://www.theaustralian.com.au/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/listing-ui-assets/img/homepage/theaustralian-small-logo.jpg" loading="lazy" alt="theaustralian" />
                </Link>
                <Link
                  className={styles.logo}
                  href="http://www.heraldsun.com.au/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/listing-ui-assets/img/homepage/heraldsun-small-logo.jpg" loading="lazy" alt="heraldsun" />
                </Link>
                <Link
                  className={styles.logo}
                  href="http://apnarm.com.au/brands/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/listing-ui-assets/img/homepage/arn-small-logo.jpg" loading="lazy" alt="arn" />
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.ads}>
            { this.state.showAds && isDesktop &&
            <Ad
              channel={this.props.currentChannel.cookieName}
              state={this.state.preferredState}
            />
            }
          </div>
        </div>
      </section>
    );
  }
}

export default withUserAgent(['isDesktop'])(NewsAndAds);
